"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUniqueId = generateUniqueId;
var stxFieldCount = 0;

function generateUniqueId() {
  if (typeof window === 'undefined') {
    stxFieldCount += 1;
  } else {
    window.stxFieldCount = window.stxFieldCount ? window.stxFieldCount + 1 : 1;
    stxFieldCount = window.stxFieldCount;
  }

  return stxFieldCount;
}